import React, { useEffect, useState } from "react";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";
import "./AdminDashboard.css"; // ✅ Import the CSS file

function AdminDashboard() {
    const [users, setUsers] = useState([]);
    const [results, setResults] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const usersSnap = await getDocs(collection(db, "users"));
            const resultsSnap = await getDocs(collection(db, "quizResults"));

            setUsers(usersSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            setResults(resultsSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        };

        fetchData();
    }, []);

    const handleDeleteUser = async (userId) => {
        await deleteDoc(doc(db, "users", userId));
        setUsers(users.filter(u => u.id !== userId));
    };

    return (
        <div className="admin-dashboard">
            <h1>Admin Dashboard</h1>

            <section className="dashboard-section">
                <h2>Registered Users</h2>
                <div className="table-container">
                    <table className="dashboard-table">
                        <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Attempt</th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        {users.map(user => (
                            <tr key={user.id}>
                                <td>{user.firstName} {user.lastName}</td>
                                <td>{user.email || "—"}</td>
                                <td>{user.attempt || 1}</td>
                                <td>
                                    <button className="delete-btn" onClick={() => handleDeleteUser(user.id)}>
                                        ❌ Remove
                                    </button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </section>

            <section className="dashboard-section">
                <h2>Quiz Results</h2>
                <div className="table-container">
                    <table className="dashboard-table">
                        <thead>
                        <tr>
                            <th>Name</th>
                            <th>Course</th>
                            <th>Score</th>
                            <th>Attempt</th>
                        </tr>
                        </thead>
                        <tbody>
                        {results.map(result => (
                            <tr key={result.id}>
                                <td>{result.firstName} {result.lastName}</td>
                                <td>{result.course}</td>
                                <td>{result.score} / {result.total}</td>
                                <td>{result.attempt}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
    );
}

export default AdminDashboard;
